module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.diseaseOrAccident),
      expression: "diseaseOrAccident"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.diseaseOrAccident = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("All")]), _vm._v(" "), (_vm.claimType !== 'personal_injury') ? _c('option', {
    attrs: {
      "value": "disease"
    }
  }, [_vm._v("Disease")]) : _vm._e(), _vm._v(" "), _c('option', {
    attrs: {
      "value": "accident"
    }
  }, [_vm._v("Accident")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-15548309!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/discount-rate-comparison/components/form/DiseaseOrAccident.vue
// module id = 1582
// module chunks = 0